module.exports = __webpack_public_path__ + "media/assets/images/category/Passover@2x-4e8c903b29c1278ff20cdcdf126d91a2.png";